// eslint-disable-next-line
import React from 'react';

import { NavLink, RouteComponentProps, withRouter } from 'react-router-dom';
import { AppContext } from '../AppContext';
import TextClick from '../basicComponents/TextClick';

export interface SideBarEntry {
	name: string;
	link: string;
}

export interface SideBarProps extends RouteComponentProps {
	entries: SideBarEntry[];
	resetSidebar: (curPath: string) => void;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface SideBarState {
}

class SideBarComponent extends React.Component<SideBarProps, SideBarState> {

	// context
	static contextType = AppContext;
	context!: React.ContextType<typeof AppContext>;

	public render(): JSX.Element {

		return (
			<React.Fragment>
				{this.props.entries
					.filter(entry => this.pageMatch(entry.link))
					.map((entry, idx) => {
						return <div className='sidebar-entry' key={idx}>
							<NavLink className='sidebar-link' activeClassName='sidebar-link-active' to={entry.link}>{entry.name}</NavLink>
						</div>
					})}
				<div className='sidebar-space' />
				{this.props.entries.filter(entry => this.pageMatch(entry.link)).length > 0 ?
					<React.Fragment>
						<TextClick className='sidebar-button' name='resetSidebar' onClick={this.handleClick} >Reset Sidebar</TextClick>
						<NavLink className='sidebar-link' activeClassName='sidebar-link-active' to='/settings'>Settings</NavLink>
					</React.Fragment>
					:
					null
				}
			</React.Fragment>
		);

	}

	private pageMatch(link: string): boolean {

		let retVal = false;

		this.context.user.getPermissionList()
			.filter( permission => permission.permissionType === 'accessPages' )
			.forEach( permission => {
				if (link.match(permission.permissionValue)) {
					retVal = true;
				}
			});

		return retVal;

	}

	private handleClick = (): void => {

		// call reset sidebar
		this.props.resetSidebar(this.props.history.location.pathname);

	}

}

const SideBar = withRouter(SideBarComponent);
export default SideBar;